// extracted by mini-css-extract-plugin
module.exports = {"form":"checkout-button_form__C__Dl","formWidthAuto":"checkout-button_formWidthAuto__it6S2","form-wrapper-credit-card":"checkout-button_form-wrapper-credit-card__vloEl"};